const tradeEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      booking: 'Reserva',
      load: 'Carga',
      salesOrder: 'Orden de Venta',
      purchaseOrder: 'Orden de Compra',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      salesOrder: {
        created: 'Orden de Venta Creada',
        updated: 'Orden de Venta Actualizada',
        deleted: 'Orden de Venta Eliminada',
        statusChanged: 'Estado de Orden de Venta Cambiado',
      },
      booking: {
        created: 'Reserva Creada',
        updated: 'Reserva Actualizada',
        deleted: 'Reserva Eliminada',
        statusChanged: 'Estado de Reserva Cambiado',
      },
      load: {
        created: 'Carga Creada',
        updated: 'Carga Actualizada',
        deleted: 'Carga Eliminada',
        statusChanged: 'Estado de Carga Cambiado',
      },
      purchaseOrder: {
        created: 'Orden de Compra Creada',
        updated: 'Orden de Compra Actualizada',
        deleted: 'Orden de Compra Eliminada',
        statusChanged: 'Estado de Orden de Compra Cambiado',
      },
    },
    fields: {
      id: 'ID',
      documentNumber: 'Número de Documento',
      type: 'Tipo',
      status: 'Estado',
      facilityId: 'ID de Instalación',
      accountId: 'ID de Cuenta',
      contactId: 'ID de Contacto',
      counterpartyReference: 'Referencia de Contraparte',
      paymentCurrency: 'Moneda de Pago',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      scheduledDate: 'Fecha Programada',
      bookingId: 'ID de Reserva',
      salesOrderId: 'ID de Orden de Venta',
      lineItems: 'Líneas de Detalle',
      itemId: 'ID de Artículo',
      quantity: 'Cantidad',
      unit: 'Unidad',
      changes: 'Cambios',
      statusChange: 'Cambio de Estado',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectBooking: 'Filtrar por Reserva',
    selectLoad: 'Filtrar por Carga',
    selectSalesOrder: 'Filtrar por Orden de Venta',
    selectPurchaseOrder: 'Filtrar por Orden de Compra',
  },
};

const financeEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      bill: 'Factura de Proveedor',
      invoice: 'Factura',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      bill: {
        created: 'Factura de Proveedor Creada',
        updated: 'Factura de Proveedor Actualizada',
        deleted: 'Factura de Proveedor Eliminada',
        voided: 'Factura de Proveedor Anulada',
        paid: 'Factura de Proveedor Pagada',
      },
      invoice: {
        created: 'Factura Creada',
        updated: 'Factura Actualizada',
        deleted: 'Factura Eliminada',
        voided: 'Factura Anulada',
        paid: 'Factura Pagada',
      },
    },
    fields: {
      id: 'ID',
      documentNumber: 'Número de Documento',
      type: 'Tipo',
      status: 'Estado',
      amount: 'Monto',
      documentDate: 'Fecha del Documento',
      dueDate: 'Fecha de Vencimiento',
      eligibleAt: 'Elegible el',
      facilityId: 'ID de Instalación',
      accountId: 'ID de Cuenta',
      creatorId: 'ID del Creador',
      paymentTerm: 'Término de Pago',
      paymentMethod: 'Método de Pago',
      notes: 'Notas',
      changes: 'Cambios',
      statusChange: 'Cambio de Estado',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectBill: 'Filtrar por Factura de Proveedor',
    selectInvoice: 'Filtrar por Factura',
  },
};

const crmEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      account: 'Cuenta',
      contact: 'Contacto',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      account: {
        created: 'Cuenta Creada',
        updated: 'Cuenta Actualizada',
        deleted: 'Cuenta Eliminada',
      },
      contact: {
        created: 'Contacto Creado',
        updated: 'Contacto Actualizado',
        deleted: 'Contacto Eliminado',
      },
    },
    fields: {
      id: 'ID',
      name: 'Nombre',
      type: 'Tipo',
      accountType: 'Tipo de Cuenta',
      isCustomer: 'Es Cliente',
      isSupplier: 'Es Proveedor',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      fullName: 'Nombre Completo',
      role: 'Rol',
      department: 'Departamento',
      accountId: 'ID de Cuenta',
      changes: 'Cambios',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectAccount: 'Filtrar por Cuenta',
    selectContact: 'Filtrar por Contacto',
  },
};

const assistantEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      chat: 'Chat',
      chatMessage: 'Mensaje de Chat',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      chat: {
        created: 'Chat Creado',
        updated: 'Chat Actualizado',
        archived: 'Chat Archivado',
        titleUpdated: 'Título de Chat Actualizado',
      },
      chatMessage: {
        created: 'Mensaje de Chat Creado',
      },
    },
    fields: {
      id: 'ID',
      title: 'Título',
      status: 'Estado',
      agentId: 'ID del Agente',
      userId: 'ID del Usuario',
      chatId: 'ID del Chat',
      role: 'Rol',
      parts: 'Partes',
      changes: 'Cambios',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectChat: 'Filtrar por Chat',
    selectChatMessage: 'Filtrar por Mensaje de Chat',
  },
};

const filesEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      file: 'Archivo',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      file: {
        created: 'Archivo Creado',
        accessed: 'Archivo Accedido',
        deleted: 'Archivo Eliminado',
        quotaExceeded: 'Cuota de Archivo Excedida',
        moved: 'Archivo Movido',
        permissionChanged: 'Permiso de Archivo Cambiado',
        setAsTemplate: 'Archivo Establecido como Plantilla',
        removedFromTemplate: 'Archivo Removido de Plantilla',
      },
    },
    fields: {
      id: 'ID',
      fileName: 'Nombre del Archivo',
      fileSize: 'Tamaño del Archivo',
      mimeType: 'Tipo MIME',
      status: 'Estado',
      entityType: 'Tipo de Entidad',
      entityId: 'ID de Entidad',
      creatorId: 'ID del Creador',
      parentId: 'ID del Padre',
      fileType: 'Tipo de Archivo',
      public: 'Público',
      accessType: 'Tipo de Acceso',
      ipAddress: 'Dirección IP',
      userAgent: 'Agente de Usuario',
      reason: 'Razón',
      oldParentId: 'ID del Padre Anterior',
      newParentId: 'ID del Padre Nuevo',
      permission: 'Permiso',
      action: 'Acción',
      templateId: 'ID de Plantilla',
      description: 'Descripción',
      attemptedSize: 'Tamaño Intentado',
      currentUsage: 'Uso Actual',
      quotaLimit: 'Límite de Cuota',
      changes: 'Cambios',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectFile: 'Filtrar por Archivo',
  },
};

const coreEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      organization: 'Organización',
      user: 'Usuario',
      facility: 'Instalación',
      facilityGroup: 'Grupo de Instalaciones',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      facility: {
        created: 'Instalación Creada',
        updated: 'Instalación Actualizada',
        deleted: 'Instalación Eliminada',
        groupAssigned: 'Grupo de Instalación Asignado',
        groupRemoved: 'Grupo de Instalación Removido',
      },
      facilityGroup: {
        created: 'Grupo de Instalaciones Creado',
        updated: 'Grupo de Instalaciones Actualizado',
        deleted: 'Grupo de Instalaciones Eliminado',
      },
      user: {
        created: 'Usuario Creado',
        updated: 'Usuario Actualizado',
        addedToOrganization: 'Usuario Agregado a Organización',
        removedFromOrganization: 'Usuario Removido de Organización',
        invited: 'Usuario Invitado',
        adminGranted: 'Administrador Otorgado',
        adminRevoked: 'Administrador Revocado',
      },
      organization: {
        created: 'Organización Creada',
        updated: 'Organización Actualizada',
        deleted: 'Organización Eliminada',
        provisioned: 'Organización Aprovisionada',
        entitlementGranted: 'Derecho Otorgado',
        entitlementRevoked: 'Derecho Revocado',
        signupCompleted: 'Registro Completado',
      },
    },
    fields: {
      id: 'ID',
      name: 'Nombre',
      type: 'Tipo',
      email: 'Correo Electrónico',
      domain: 'Dominio',
      timezone: 'Zona Horaria',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phoneNumber: 'Número de Teléfono',
      facilityName: 'Nombre de Instalación',
      facilityType: 'Tipo de Instalación',
      facilityGroupId: 'ID de Grupo de Instalaciones',
      organizationId: 'ID de Organización',
      userId: 'ID del Usuario',
      facilityId: 'ID de Instalación',
      entitlement: 'Derecho',
      address: 'Dirección',
      changes: 'Cambios',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectOrganization: 'Filtrar por Organización',
    selectUser: 'Filtrar por Usuario',
    selectFacility: 'Filtrar por Instalación',
    selectFacilityGroup: 'Filtrar por Grupo de Instalaciones',
  },
};

const inventoryEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      item: 'Artículo',
      category: 'Categoría',
      itemGroup: 'Grupo de Artículos',
      inventoryTag: 'Etiqueta de Inventario',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      item: {
        created: 'Artículo Creado',
        updated: 'Artículo Actualizado',
        deleted: 'Artículo Eliminado',
      },
      category: {
        created: 'Categoría Creada',
        updated: 'Categoría Actualizada',
        deleted: 'Categoría Eliminada',
      },
      itemGroup: {
        created: 'Grupo de Artículos Creado',
        updated: 'Grupo de Artículos Actualizado',
        deleted: 'Grupo de Artículos Eliminado',
      },
      inventoryTag: {
        created: 'Etiqueta de Inventario Creada',
        updated: 'Etiqueta de Inventario Actualizada',
        deleted: 'Etiqueta de Inventario Eliminada',
      },
    },
    fields: {
      id: 'ID',
      name: 'Nombre',
      description: 'Descripción',
      notes: 'Notas',
      skuNumber: 'Número de SKU',
      categoryId: 'ID de Categoría',
      itemGroupId: 'ID de Grupo de Artículos',
      parentId: 'ID del Padre',
      number: 'Número',
      tagNumber: 'Número de Etiqueta',
      tagType: 'Tipo de Etiqueta',
      status: 'Estado',
      grossQuantity: 'Cantidad Bruta',
      tare: 'Tara',
      itemId: 'ID de Artículo',
      facilityId: 'ID de Instalación',
      isRevised: 'Es Revisado',
      quantityCaptureMethod: 'Método de Captura de Cantidad',
      tareCaptureMethod: 'Método de Captura de Tara',
      generatedAt: 'Generado el',
      changes: 'Cambios',
      noDataAvailable: 'Sin datos disponibles',
      attributes: 'Atributos',
      dataType: 'Tipo de Dato',
      required: 'Requerido',
      validationExpr: 'Expresión de Validación',
      options: 'Opciones',
    },
  },
  filter: {
    selectItem: 'Filtrar por Artículo',
    selectCategory: 'Filtrar por Categoría',
    selectItemGroup: 'Filtrar por Grupo de Artículos',
    selectInventoryTag: 'Filtrar por Etiqueta de Inventario',
  },
};

const transportationEventsView = {
  tabs: {
    events: 'Eventos',
    inbox: 'Bandeja de Entrada',
  },
  sidebar: {
    all: 'Todos',
    aggregateTypes: {
      asset: 'Activo',
      driver: 'Conductor',
      truck: 'Camión',
      trailer: 'Remolque',
      route: 'Ruta',
      service: 'Servicio',
      containerType: 'Tipo de Contenedor',
      transportationType: 'Tipo de Transporte',
      freightForwarder: 'Agente de Carga',
      freightLine: 'Línea de Carga',
      shippingCarrier: 'Transportista',
    },
  },
  list: {
    empty: 'No se encontraron eventos',
    idPrefix: 'ID:',
    notAvailable: 'N/D',
  },
  detail: {
    empty: 'Selecciona un evento para ver los detalles',
    metadata: {
      title: 'Metadatos',
      eventId: 'ID del Evento',
      aggregateId: 'ID del Agregado',
      topic: 'Tema',
      version: 'Versión',
      retryCount: 'Cantidad de Reintentos',
      createdAt: 'Creado el',
      createdBy: 'Creado por',
      lastRetry: 'Último Reintento',
    },
    payload: 'Contenido',
    notAvailable: 'N/D',
    toggle: {
      details: 'Detalles',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Anterior',
      currentLabel: 'Actual',
      noChanges: 'No se detectaron cambios',
    },
    eventTypes: {
      asset: {
        created: 'Activo Creado',
        updated: 'Activo Actualizado',
        deleted: 'Activo Eliminado',
      },
      driver: {
        created: 'Conductor Creado',
        updated: 'Conductor Actualizado',
        deleted: 'Conductor Eliminado',
        certificationAdded: 'Certificación de Conductor Agregada',
        certificationUpdated: 'Certificación de Conductor Actualizada',
        certificationDeleted: 'Certificación de Conductor Eliminada',
      },
      truck: {
        created: 'Camión Creado',
        updated: 'Camión Actualizado',
        deleted: 'Camión Eliminado',
      },
      trailer: {
        created: 'Remolque Creado',
        updated: 'Remolque Actualizado',
        deleted: 'Remolque Eliminado',
      },
      route: {
        created: 'Ruta Creada',
        updated: 'Ruta Actualizada',
        deleted: 'Ruta Eliminada',
        statusChanged: 'Estado de Ruta Cambiado',
      },
      service: {
        created: 'Servicio Creado',
        updated: 'Servicio Actualizado',
        deleted: 'Servicio Eliminado',
        statusChanged: 'Estado de Servicio Cambiado',
      },
    },
    fields: {
      id: 'ID',
      documentNumber: 'Número de Documento',
      type: 'Tipo',
      status: 'Estado',
      name: 'Nombre',
      description: 'Descripción',
      notes: 'Notas',
      licensePlate: 'Placa',
      licensePlateExpiration: 'Vencimiento de Placa',
      vin: 'VIN',
      capacity: 'Capacidad',
      country: 'País',
      state: 'Estado',
      currentLocation: 'Ubicación Actual',
      lastLocationTime: 'Última Hora de Ubicación',
      transportationTypeId: 'ID de Tipo de Transporte',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      licenseNumber: 'Número de Licencia',
      licenseExpiration: 'Vencimiento de Licencia',
      dateOfBirth: 'Fecha de Nacimiento',
      hireDate: 'Fecha de Contratación',
      terminationDate: 'Fecha de Terminación',
      rank: 'Rango',
      priority: 'Prioridad',
      routeDate: 'Fecha de Ruta',
      startedAt: 'Iniciado el',
      completedAt: 'Completado el',
      assignedAt: 'Asignado el',
      estimatedArrival: 'Llegada Estimada',
      facilityGroupId: 'ID de Grupo de Instalaciones',
      driverId: 'ID del Conductor',
      haulerId: 'ID del Transportista',
      truckId: 'ID del Camión',
      trailerId: 'ID del Remolque',
      routeId: 'ID de Ruta',
      facilityId: 'ID de Instalación',
      accountId: 'ID de Cuenta',
      contactId: 'ID de Contacto',
      scheduledWindowStart: 'Inicio de Ventana Programada',
      scheduledWindowEnd: 'Fin de Ventana Programada',
      changes: 'Cambios',
      statusChange: 'Cambio de Estado',
      noDataAvailable: 'Sin datos disponibles',
    },
  },
  filter: {
    selectAsset: 'Filtrar por Activo',
    selectDriver: 'Filtrar por Conductor',
    selectTruck: 'Filtrar por Camión',
    selectTrailer: 'Filtrar por Remolque',
    selectRoute: 'Filtrar por Ruta',
    selectService: 'Filtrar por Servicio',
  },
};

const routes = {
  title: 'Registro de Auditoría',
  notImplemented: 'Aún no implementado',
  groups: {
    modules: 'Módulos',
  },
  modules: {
    trade: 'Comercio',
    finance: 'Finanzas',
    transportation: 'Transporte',
    crm: 'CRM',
    core: 'Core',
    inventory: 'Inventario',
    assistant: 'Asistente',
    files: 'Archivos',
  },
};

const filters = {
  dateRange: {
    label: 'Rango de Fechas',
    clear: 'Limpiar',
  },
};

const pagination = {
  of: 'de',
};

export const es = {
  tradeEventsView,
  financeEventsView,
  crmEventsView,
  assistantEventsView,
  filesEventsView,
  inventoryEventsView,
  coreEventsView,
  transportationEventsView,
  routes,
  filters,
  pagination,
};
